module.exports = __webpack_public_path__ + "assets/873aaaa9e869d3c98dfe3920aeddc9cc.png";